import one from "../../assets/eat.mp3";
import {
  R1,
  L1,
  R1L3,
  R1L2R1,
  R1L1R1L1,
  R1L1R2,
  R4,
  R3L1,
  R2L2,
  R2L1R1,
  L1R3,
  L1R2L1,
  L1R1L1R1,
  L1R1L2,
  L4,
  L3R1,
  L2R2,
  L2R1L1,
} from "../playersMoves/playerTwoMovesLogic";
import {
  R1_P1,
  L1_P1,
  R1L3_P1,
  R1L2R1_P1,
  R1L1R1L1_P1,
  R1L1R2_P1,
  R4_P1,
  R3L1_P1,
  R2L2_P1,
  R2L1R1_P1,
  L1R3_P1,
  L1R2L1_P1,
  L1R1L1R1_P1,
  L1R1L2_P1,
  L4_P1,
  L3R1_P1,
  L2R2_P1,
  L2R1L1_P1,
} from "../playersMoves/playerOneMovesLogic";
import changeFromPawnToDhama from "../dhamaMoves/changeFromPawnToDhama";
import checkMustEat from "../mustEat/checkMustEat";
import EatMore from "../eatMore/eatMore";

function handleSquareClickEatMore(
  i,
  j,
  squareRef,
  squareRefPawns,
  boardData,
  setBoardData,
  playerTurn,
  prevSquare,
  setPrevSquare,
  setPlayerTurn,
  boardDataRef,
  x,
  previouspawnMustEat,
  dhamaIndex,
  pawnsInTouch,
  activeSound
) {
  const clickedSquareData = boardData.find(
    (square) => square[1] === i && square[2] === j
  );
  const [squareColor, row, col] = clickedSquareData;
  // const [prevRow, prevCol] = prevSquare;
  const prevSquareIndex = previouspawnMustEat;
  if (
    ((boardData[prevSquareIndex][0] === 2 ||
      boardData[prevSquareIndex][0] === 32) &&
      playerTurn === 2) ||
    ((boardData[prevSquareIndex][0] === 1 ||
      boardData[prevSquareIndex][0] === 31) &&
      playerTurn === 1)
  ) {
    squareRef.current[prevSquareIndex].classList.add("gray-box");
  }
  const currentSquareIndex = row * 10 + col;
  let moves = [];
  if (playerTurn === 2) {
    moves = [
      R1,
      L1,
      R1L3,
      R1L2R1,
      R1L1R1L1,
      R1L1R2,
      R4,
      R3L1,
      R2L2,
      R2L1R1,
      L1R3,
      L1R2L1,
      L1R1L1R1,
      L1R1L2,
      L4,
      L3R1,
      L2R2,
      L2R1L1,
    ];
  } else if (playerTurn === 1) {
    moves = [
      R1_P1,
      L1_P1,
      R1L3_P1,
      R1L2R1_P1,
      R1L1R1L1_P1,
      R1L1R2_P1,
      R4_P1,
      R3L1_P1,
      R2L2_P1,
      R2L1R1_P1,
      L1R3_P1,
      L1R2L1_P1,
      L1R1L1R1_P1,
      L1R1L2_P1,
      L4_P1,
      L3R1_P1,
      L2R2_P1,
      L2R1L1_P1,
    ];
  }
  let executed = false;
  for (let i = 0; i < moves.length; i++) {
    const move = moves[i];
    if (
      move(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        setPlayerTurn,
        playerTurn,
        squareRef,
        squareRefPawns,
        setBoardData
      )
    ) {
      executed = true;
      if (activeSound) {
        new Audio(one).play();
      }
      break;
    }
  }
  if (executed) {
    x = 1;
    setPrevSquare([row, col]);
    squareRef.current[prevSquareIndex].classList.remove("gray-box");
    setTimeout(() => {
      x = EatMore(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        setPlayerTurn,
        playerTurn,
        squareRefPawns,
        setBoardData,
        x
      );
      changeFromPawnToDhama(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        setPlayerTurn,
        playerTurn,
        squareRef,
        squareRefPawns,
        boardDataRef,
        dhamaIndex,
        activeSound
      );
      if (x !== 2) {
        checkMustEat(
          prevSquareIndex,
          currentSquareIndex,
          boardData,
          playerTurn,
          pawnsInTouch
        );
      }
    });
  } else {
    x = 2;
  }
  return x;
}
export default handleSquareClickEatMore;
